import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const Accessories = () => {
  return (
    <div>
      <Navbar />
      Accessories      
      <Footer />

    </div>
  )
}

export default Accessories
